import type { TFunction } from 'i18next';

/** Description parts separated by a middle dot, empty parts skipped. */
export const joinDescriptionParts = (parts: React.ReactNode[]): React.ReactNode => {
  const present = parts.filter((part) => part !== null && part !== undefined && part !== false && part !== '');
  return present.map((part, index) => (
    <span key={index}>
      {index > 0 && ' · '}
      {part}
    </span>
  ));
};

export const reactionsLine = (reactions: string[], t: TFunction<'records'>): string | undefined =>
  reactions.length > 0 ? `${t('reactions')}: ${reactions.join(', ')}` : undefined;
